import { useQuery } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const onGetProjectTransactions = (ID) => Axios.get(`/projects/TransactionsGroupedByModelAndDay/${ID}`);

const useProjectTransactions = (ID) => {
    return useQuery({
        queryKey: ['projecttransactions', ID],
        queryFn: () => onGetProjectTransactions(ID),
        staleTime: 10000,
        cacheTime: 10000,
        retry: false,
    });
};

const forceReloadProjectTransactions = (ID) => {
    return queryClient.invalidateQueries({ queryKey: ['projecttransactions', ID] });
};

export { useProjectTransactions, forceReloadProjectTransactions };
